var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetsTalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 68,
    viewBox: "0 0 145 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_1_4834)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 10.8999,
    width: 120.94,
    height: 43,
    rx: 21.5,
    fill: "#4660EC",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 10.8999,
    width: 120.94,
    height: 43,
    rx: 21.5,
    fill: "url(#paint0_radial_1_4834)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_4834)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 29.7048,
    width: 5.39,
    height: 5.39,
    rx: 2.695,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.5929 37.3999V28.3279H48.9096V36.1588H53.0172V37.3999H47.5929ZM54.0869 37.3999V28.3279H59.8829V29.569H55.4036V32.1142H59.1269V33.3553H55.4036V36.1588H59.8829V37.3999H54.0869ZM63.6575 37.3999V29.569H60.6398V28.3279H67.9919V29.569H64.9742V37.3999H63.6575ZM69.1261 31.3519L69.208 30.766C69.3886 30.7786 69.5293 30.745 69.6301 30.6652C69.7309 30.5854 69.7981 30.4741 69.8317 30.3313C69.8653 30.1885 69.8716 30.0268 69.8506 29.8462H69.1261V28.3279H70.5184V29.9722C70.5184 30.4678 70.3987 30.8416 70.1593 31.0936C69.9241 31.3456 69.5797 31.4317 69.1261 31.3519ZM75.1065 37.5889C74.4555 37.5889 73.8675 37.4776 73.3425 37.255C72.8217 37.0282 72.3912 36.7069 72.051 36.2911C71.715 35.8711 71.4966 35.3734 71.3958 34.798L72.7692 34.5901C72.9078 35.1445 73.1976 35.5771 73.6386 35.8879C74.0796 36.1945 74.5941 36.3478 75.1821 36.3478C75.5475 36.3478 75.8835 36.2911 76.1901 36.1777C76.4967 36.0601 76.7424 35.8942 76.9272 35.68C77.1162 35.4616 77.2107 35.2012 77.2107 34.8988C77.2107 34.735 77.1813 34.5901 77.1225 34.4641C77.0679 34.3381 76.9902 34.2289 76.8894 34.1365C76.7928 34.0399 76.6731 33.958 76.5303 33.8908C76.3917 33.8194 76.2384 33.7585 76.0704 33.7081L73.7457 33.0214C73.5189 32.9542 73.2879 32.8681 73.0527 32.7631C72.8175 32.6539 72.6012 32.5132 72.4038 32.341C72.2106 32.1646 72.0531 31.9483 71.9313 31.6921C71.8095 31.4317 71.7486 31.1167 71.7486 30.7471C71.7486 30.1885 71.8914 29.716 72.177 29.3296C72.4668 28.939 72.8574 28.645 73.3488 28.4476C73.8402 28.246 74.3904 28.1452 74.9994 28.1452C75.6126 28.1536 76.1607 28.2628 76.6437 28.4728C77.1309 28.6828 77.5341 28.9852 77.8533 29.38C78.1767 29.7706 78.3993 30.2452 78.5211 30.8038L77.1099 31.0432C77.0469 30.703 76.9125 30.4111 76.7067 30.1675C76.5009 29.9197 76.2489 29.7307 75.9507 29.6005C75.6525 29.4661 75.3291 29.3968 74.9805 29.3926C74.6445 29.3842 74.3358 29.4346 74.0544 29.5438C73.7772 29.653 73.5546 29.8063 73.3866 30.0037C73.2228 30.2011 73.1409 30.4279 73.1409 30.6841C73.1409 30.9361 73.2144 31.1398 73.3614 31.2952C73.5084 31.4506 73.689 31.5745 73.9032 31.6669C74.1216 31.7551 74.3379 31.8286 74.5521 31.8874L76.2279 32.3599C76.4379 32.4187 76.6752 32.4985 76.9398 32.5993C77.2086 32.6959 77.4669 32.8324 77.7147 33.0088C77.9667 33.1852 78.1746 33.4204 78.3384 33.7144C78.5022 34.0042 78.5841 34.3696 78.5841 34.8106C78.5841 35.2684 78.4917 35.6716 78.3069 36.0202C78.1221 36.3646 77.868 36.6544 77.5446 36.8896C77.2254 37.1206 76.8558 37.2949 76.4358 37.4125C76.0158 37.5301 75.5727 37.5889 75.1065 37.5889ZM84.7109 37.3999V29.569H81.6932V28.3279H89.0453V29.569H86.0276V37.3999H84.7109ZM89.1774 37.3999L92.1258 28.3279H94.0221L96.9705 37.3999H95.6034L92.8881 29.1217H93.2283L90.5445 37.3999H89.1774ZM90.7083 35.3524V34.1176H95.4459V35.3524H90.7083ZM98.2267 37.3999V28.3279H99.5434V36.1588H103.651V37.3999H98.2267ZM104.721 37.3999V28.3279H106.037V32.5615L109.836 28.3279H111.474L107.461 32.7568L111.77 37.3999H110.082L106.037 33.0655V37.3999H104.721Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_1_4834",
    x: 0,
    y: 0.899902,
    width: 144.94,
    height: 67,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4834"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4834",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1_4834"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_4834",
    x: 20,
    y: 19.7048,
    width: 25.39,
    height: 25.3899,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1_4834"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4834"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4834",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_4834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 10.8999) scale(128.267 129.077)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CA1FA",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CA1FA",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetsTalk);
export default __webpack_public_path__ + "static/media/LetsTalk.e9eeba287ccdf326c409d894d2a04ac0.svg";
export { ForwardRef as ReactComponent };